export const hasInvalidMarkdownLink = (text?: string): boolean => {
    if (!text) {
        return false;
    }

    for (let index = 0; index < text.length; index += 1) {
        if (text[index] !== '[') {
            continue;
        }

        const closeBracketIndex = text.indexOf(']', index + 1);
        if (closeBracketIndex === -1) {
            continue;
        }

        if (text[closeBracketIndex + 1] !== '(') {
            continue;
        }

        const closeParenIndex = text.indexOf(')', closeBracketIndex + 2);
        if (closeParenIndex === -1) {
            return true;
        }

        index = closeParenIndex;
    }

    return false;
};
